module.exports = "/images/Taiwan.png?c8d7c265e27f40bdd445debbf19b011b";